import { getMainCookieContext, getConsentCookieContext, getExperiments, getRequestID } from './utils';

export const mainCookie = () => ({
  schema: 'iglu:org.ecosia/ecfg_context/jsonschema/1-0-3',
  data: getMainCookieContext(),
});

export const consentCookie = () => ({
  schema: 'iglu:org.ecosia/eccc_context/jsonschema/1-0-1',
  data: {
    cookie_consent: getConsentCookieContext(),
  },
});

export const abTests = () => ({
  schema: 'iglu:org.ecosia/abtest_context/jsonschema/1-0-1',
  data: {
    ab_tests: getExperiments(),
  },
});

export const requestID = () => ({
  schema: 'iglu:org.ecosia/ecrq_context/jsonschema/1-0-0',
  data: {
    request_id: getRequestID(),
  },
});
